"use client";
import { SetStateAction, useState } from "react";
import { useQuery } from "react-query";

import Carousel from "react-material-ui-carousel";
import _ from "lodash";
import axios from "axios";

import { getTextureValue } from "../../data/textures";
import { getTextureLabel } from "../../data/textures";

import {
  Box,
  Typography,
  CircularProgress,
  Link
} from "@mui/material";



import "./product.css";
import Slider from "@mui/material/Slider";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";
import { PieChart } from "@mui/x-charts/PieChart";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import MediaQuery, { useMediaQuery } from "react-responsive";
import { brandingColors } from "../../components/utils";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/header/header";
import ReducedFooterComponent from "../../components/footer/reduced-footer";
import { ArrowBack } from "@mui/icons-material";
import CustomerReviewsComponent from "../../components/product-tile/customer-reviews";
import { combinedTags } from "../../data/tags";

const getskincareProduct = () => {
  const options = {
    method: "GET",
    url: `https://d222hu8pcowl39.cloudfront.net/default/querying?TableName=product`,
  };

  return axios.request(options);
};

const getSignals = async () => {
  const skincareProduct = await getskincareProduct();
  const skincareProducts = _.get(skincareProduct, "data.Items") || [];
  return { skincareProducts };
};

export default function Product(): JSX.Element {
  const urlParams = new URLSearchParams(window.location.search);
  let code = urlParams.get("code");
  let back = urlParams.get("back");

  /* back START */
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(`/solutions?q=${state.question}&quizId=${state.quizId}`);
  }
  /* back END */

  const { data, status } = useQuery("posts", getSignals);

  let products = _.get(data, "skincareProducts");

  const [message, setMessage] = useState("");

  const product = _.find(products, (p) => {
    return p.code === code;
  });

  //console.log(product);

  const [open, setOpenState] = useState(false);

  const isLaptop = useMediaQuery({ query: "(max-width: 992px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  if (status === "loading") {
    return (
      <div className="loading-container">
        <CircularProgress />
      </div>
    );
  }

  let images: any[] = [];

  if (product.imageLocation) {
    images = _.split(product.imageLocation, ",");
  }

  const handleChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setMessage(event.target.value);

    console.log("value is:", event.target.value);
  };

  //const features = _.split(product.productFeature, ",");
  let features : string[] = [];
  let tags: string[];

  if (Array.isArray(product.tags)) {
    tags = product.tags;
  } else {
    tags = _.split(product.tags, ",");
  }
  features = _.filter(tags, (t) => {
    return !combinedTags.includes(t)
  })

  const shareUrl = window.location.href;

  // skin type
  let skinTypes : number[] = [1];
  if (product.skinType !== undefined) {
    skinTypes = [];
    _.map(product.skinType, (st) => skinTypes.push(_.toNumber(st)));
  }
  
  const skinTypeMarks = [
    {
      value: 1,
      label: "Oily",
    },
    {
      value: 2,
      label: "Combination-Oily",
    },
    {
      value: 3,
      label: "Combination-Dry",
    },
    {
      value: 4,
      label: "Dry",
    },
  ];

  // texture
  const texture = getTextureValue(product);

  // ***** effective keywords start *****
  const keywords =
    product.effectKeywords !== "" ? _.split(product.effectKeywords, "/") : [];

  const getKeywordLabel = (keyword: string): string => {
    return _.split(keyword, ":")[0];
  };

  const getScore = (keyword: string): number => {
    return _.toNumber(_.split(keyword, ":")[1]);
  };
  // ***** effective keywords end *****

  // ingredients
  const good = product.goodIngredients !== null && product.goodIngredients !== '' ? product.goodIngredients : 0;
  const moderate =
    product.moderateIngredients !== null && product.moderateIngredients !== '' ? product.moderateIngredients : 0;
  const risk =
    product.riskIngredients !== ""
      ? _.split(product.riskIngredients, ",").length
      : 0;

  const getRiskIngredient = (): string => {
    if (risk === 1) {
      return "Risk ingredient: " + product.riskIngredients;
    } else if (risk > 1) {
      return "Risk ingredients: " + product.riskIngredients;
    } else {
      return "";
    }
  };

  return (
    <div className="product-page">
      <Header showLogo={true} />
      <div className="main">
        <div className="container">
        <div className="wrapper">
        <Box
          sx={{
            width: "100%",
            color: brandingColors["green-font"],
            margin: "0 auto",
          }}
        >
      

      {/* back to results */}
      {state === null ? '' :
      (<Box
        sx={{
          width: "100%",
          padding: "12px 24px 12px 24px",
        }}
      >
        <Box
          sx={{
            fontSize: "16px",
          }}
          onClick={handleBackClick}
          id="back-btn"
        >
          {/*<img className="back-icon" src={iconArrowBack} />*/}
          
          <ArrowBack />
          <span>Back to results</span>
        </Box>
      </Box>) }

      {/* centre */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "8px 24px 48px 24px",
        }}
      >
        <Box
          className="summary"
          sx={{
            margin: "10px 12px",
            padding: "20px",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: { xs: "flex", sm: "none" },
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-around",
            }}
          >
            <Carousel
              fullHeightHover={false} // We want the nav buttons wrapper to only be as big as the button element is
              swipe={true}
              animation={"slide"}
              duration={1500}
              interval={10000}
            >
              {_.map(images, (img) => (
                  <Box
                    sx={{
                      padding: "10px 20px",
                      width: { xs: "100%", sm: "33%" },
                      borderRadius: "10px",
                    }}
                  >
                    <Box
                      sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: { xs: "column", md: "column" },
                      justifyContent: "space-around",
                    }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                        }}
                      >
                        <img
                      alt=""
                      src={`https://d3meuv9j0uoyqk.cloudfront.net/${_.trim(
                        img
                      )}`}
                      width="100%"
                      style={{ objectFit: "cover", maxHeight: "500px" }}/>
                      </Box>
                    </Box>
                  </Box>
                ))}
            </Carousel>
          </Box>

          {/* image gallery */}
          <Box
            sx={{
              width: "50%",
              display: { xs: "none", sm: "flex" },
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              color: brandingColors["grey-font"],
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridRowGap: "12px",
                gridTemplateRows: "1fr 1fr 1fr"
              }}
            >
              {_.tail(images) &&
                _.map(_.tail(images), (img) => (
                  <Zoom>
                    <img
                      alt=""
                      src={`https://d3meuv9j0uoyqk.cloudfront.net/${_.trim(
                        img
                      )}`}
                      width="100%"
                      height="158px"
                      style={{
                        objectFit: "cover",
                        maxHeight: "158px",
                        borderRadius: "24px",
                      }}
                    />
                  </Zoom>
                ))}
            </Box>

            <Box
              sx={{
                flex: "0 0 62%",
              }}
            >
              <Zoom>
                <img
                  alt=""
                  src={`https://d3meuv9j0uoyqk.cloudfront.net/${_.trim(
                    _.head(images)
                  )}`}
                  width="100%"
                  height="499px"
                  style={{
                    objectFit: "cover",
                    maxHeight: "499px",
                    borderRadius: "24px",
                  }}
                />
              </Zoom>
            </Box>
          </Box>

          {/* brand and name */}
          <Box
            className="brand-name-wrapper"
            sx={{
              width: "50%",
              display: { xs: "flex", sm: "flex" },
              flexDirection: "column",
              color: brandingColors["green-font"],
              marginLeft: "32px",
            }}
          >
            {/*<img className="share" src={iconShare} />*/}
            <Box className="share">
              <TwitterShareButton url={shareUrl} title={product.name}>
                <XIcon size={32} round />
              </TwitterShareButton>
              <FacebookShareButton url={shareUrl}>
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <WhatsappShareButton
                url={shareUrl}
                title={product.name}
                separator=":: "
              >
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
            </Box>
            <Typography
              variant={"h6"}
              sx={{
                color: brandingColors["green-font"],
                fontSize: "16px",
                lineHeight: "42px",
              }}
            >
              {product.brand}
            </Typography>
            <div className="product-name-price">
              <Typography
                variant={"h5"}
                sx={{
                  color: brandingColors["green-font"],
                  fontSize: "20px",
                  fontWeight: "600",
                  lineHeight: "36px",
                }}
              >
                {product.name}
              </Typography>
              <div className="price">{product.price}</div>
            </div>
            
            <Typography
              sx={{
                marginTop: "8px",
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "36px",
              }}
            >
              {product.frontendDescription}
            </Typography>

            <Box className="buy-btn-box">
              <Box
                sx={{
                  width: "30%",
                  textAlign: "center",
                  height: "inherit",
                  borderRadius: "4px"
                }}
              >
                <Link className="btn-buy" href={product.link} target="_blank"
                  sx={{
                    color: "#01402f !important",
                    background: "#d8f397 !important",
                    height: "100%",
                    display: "flex",
                    textDecoration: "none",
                    justifyContent: "center",
                    lineHeight: "60px"
                  }}
                >
                  Buy
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box className="feature-and-rating">
          {/* Product Feature */}
          <Box
            className="feature-slot"
            sx={{
              borderRadius: "10px",
            }}
          >
            <Typography
              variant={"subtitle2"}
              sx={{
                margin: "20px 0",
                color: brandingColors["green-font"],
                fontSize: "20px",
              }}
            >
              Product Feature
            </Typography>
            <Box
              className="feature-wrapper"
              sx={{
                display: "flex",
              }}
            >
              {_.map(features, (feature) => (
                <Box className="feature">{feature}</Box>
              ))}
            </Box>
            {/*<Typography
            variant={"subtitle2"}
            sx={{
              margin: "20px 0",
            }}
          >
            {product.productFeature ? product.productFeature : ''}}
          </Typography>*/}
            {/*<Typography
            variant={"subtitle2"}
            sx={{
              margin: "20px 0",
              color: brandingColors["red"],
            }}
          >
            Product description
          </Typography>
          <Typography
            variant={"subtitle2"}
            sx={{
              margin: "20px 0",
            }}
          >
            {product.description || "-"}
          </Typography>
          <Typography
            variant={"subtitle2"}
            sx={{
              margin: "20px 0",
            }}
          >
            {product.productFeature ? `Product Features: ${product.productFeature}` : ''}
          </Typography>*/}
          </Box>

          {/* review and rating */}
          <Box className="rating-slot">
            {product.rating ? (
              <Box className="rating">
                <img src="/assets/score-circle.svg" />
                <Box className="rating-number">
                  <Typography className="number" variant={"subtitle2"}>
                    {product.rating}
                  </Typography>
                </Box>
              </Box>
            ) : (
              ""
            )}
          </Box>
        </Box>

        {/* skin type and texture */}
        <Box className="skinType-texture">
          <Box className="skin-type">
            Skin Type
            <Box className="sliders">
              <Box className="slider">
                <Slider
                  disabled
                  defaultValue={skinTypes}
                  step={1}
                  min={0.9}
                  max={4}
                  marks={skinTypeMarks}
                  color="secondary"
                />
              </Box>
            </Box>
          </Box>
          <Box className="texture">
            Texture
            <Box className="sliders">
              <Box className="slider">
                <Slider
                  disabled
                  defaultValue={texture}
                  step={1}
                  min={0.6}
                  max={8}
                  color="secondary"
                  marks={getTextureLabel(product)}
                ></Slider>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* effective keywords */}
        <Box className="effective-keywords-slot">
          <Box className="effective-keywords-sliders">
            {_.map(keywords, (keyword) => (
              <Box className="slider">
                {getKeywordLabel(keyword)}
                <Box className="slider-wrapper">
                  <Slider
                    disabled
                    defaultValue={getScore(keyword)}
                    step={0.1}
                    min={0.8}
                    max={5.0}
                    color="secondary"
                  ></Slider>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="score">{getScore(keyword)}</span>
                </Box>
              </Box>
            ))}
          </Box>

          {/*<Typography
            variant={"subtitle2"}
            sx={{
              margin: "20px 0",
              color: brandingColors["red"],
            }}
          >
            Product Details
          </Typography>
          <Typography
            variant={"subtitle2"}
            sx={{
              margin: "20px 0",
            }}
          >
            Body Parts: {product.bodyPart}
          </Typography>
          <Typography
            variant={"subtitle2"}
            sx={{
              margin: "20px 0",
            }}
          >
            scented: {product.scented? 'Yes': "No"}
          </Typography>
          <Typography
            variant={"subtitle2"}
            sx={{
              margin: "20px 0",
            }}
          >
            Suitable for sensitive skin: {product.sensitiveSkin? 'Yes': "No"}
          </Typography>*/}
        </Box>

        {/* Ingredient */}
        {good === 0 && moderate === 0 && risk === 0 ? '' : 
        <Box className="ingredients">
          <Box className="ingredients-wrapper">
            <Typography
              variant={"subtitle2"}
              sx={{
                fontSize: "20px",
                marginBottom: "20px",
              }}
            >
              Ingredients
            </Typography>

            {isMobile ? (
              <PieChart
                series={[
                  {
                    data: [
                      { id: 0, value: good, color: "#01402f", label: "Good" },
                      { id: 1, value: moderate, color: "#d8f397", label: "Moderate"},
                      { id: 2, value: risk, color: "#B39EB5", label: "Risk" },
                    ],
                  },
                ]}
                slotProps={{
                  legend: {
                    labelStyle: {
                      fill: '#01402f',
                    },
                  },
                }}
                width={340}
                height={170}
              />
            ) : isLaptop ? (
              <PieChart
                series={[
                  {
                    data: [
                      { id: 0, value: good, color: "#01402f", label: "Good" },
                      { id: 1, value: moderate, color: "#d8f397", label: "Moderate"},
                      { id: 2, value: risk, color: "#B39EB5", label: "Risk" },
                    ],
                    outerRadius: 150,
                  },
                ]}
                slotProps={{
                  legend: {
                    labelStyle: {
                      fill: '#01402f',
                    },
                  },
                }}
                width={700}
                height={350}
              />
            ) : (
              <PieChart
                series={[
                  {
                    data: [
                      { id: 0, value: good, color: "#01402f", label: "Good" },
                      { id: 1, value: moderate, color: "#d8f397", label: "Moderate"},
                      { id: 2, value: risk, color: "#B39EB5", label: "Risk" },
                    ],
                    outerRadius: 200,
                  },
                ]}
                slotProps={{
                  legend: {
                    labelStyle: {
                      fill: '#01402f',
                    },
                  },
                }}
                width={800}
                height={400}
              />
            )}
            <Box className="risk-ingredient">{getRiskIngredient()}</Box>
          </Box>
        </Box>}

        {/* customer reviews */}
        <div className="customer-reviews-slot">
          <CustomerReviewsComponent product={product} />
        </div>
        
        <ReducedFooterComponent />
      </Box>
    </Box>
    </div>
    </div>
    </div>
    </div>
  );
}
